import { FC, useMemo } from "react";
import { Alert, Button, Container, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavigationLessAppPage } from "shared-ts-ui-app-boot";
import { useLanguage } from "shared-ts-language";
import { useAppTheme } from "shared-ts-ui-app-theme-provider";

export const RegisterUserOAuthError: FC = () => {
  const { t: tIdentity } = useTranslation("shared-ts-ui-identity");
  const { t: tMyChimney } = useTranslation("my-chimney-ts-translations");
  const { language, setLanguage } = useLanguage();
  const { themeName, setTheme } = useAppTheme();

  const urlParams = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      code: params.get("code"),
      error: params.get("error"),
      errorDescription: params.get("error_description"),
    };
  }, []);

  const handleCancel = () => {
    window.location.href = "/";
  };

  const handleTryAgain = () => {
    // Clear error params and restart the registration flow
    window.location.href = "/register-user";
  };

  return (
    <NavigationLessAppPage
      language={language}
      onLanguageChange={setLanguage}
      themeName={themeName}
      onThemeChange={setTheme as React.Dispatch<React.SetStateAction<string>>}
      flexGrowHeader={"auto"}
      sx={{ pt: 2, pb: 2 }}
    >
      <Container
        maxWidth={"xs"}
        style={{
          flexGrow: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack direction={"column"} useFlexGap gap={2} alignItems={"center"}>
          <Alert severity={"error"} variant={"outlined"}>
            {urlParams.errorDescription
              ? decodeURIComponent(
                  urlParams.errorDescription.replace(/\+/g, " ")
                )
              : tIdentity("Failed to sign in")}
          </Alert>
          <Stack direction={"row"} gap={2}>
            <Button variant={"contained"} onClick={handleTryAgain}>
              {tIdentity("Try again")}
            </Button>
            <Button variant={"outlined"} onClick={handleCancel}>
              {tMyChimney("Cancel")}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </NavigationLessAppPage>
  );
};
